/* @flow */
import * as React from 'react'
import getDisplayName from 'app/components/utils/getDisplayName'

// seems that this Class annotation only works for component class definitions
// and not for pure functional components...
export function withIcon(Child: Class<React.Component<*, *>> | Function) {
    const WithIcon = (props: Object) => (
        <div className="iconParent">
            <Child {...props} />
        </div>
    )

    WithIcon.displayName = `WithIcon(${getDisplayName(Child)})`

    return WithIcon
}

function Icon({
    type,
    size = 'standard',
    color,
    hoverColor,
    className,
}: {
    color?: IconColor,
    hoverColor?: IconColor,
    size?: IconSize,
    type: IconType,
    className?: string,
}) {
    let classes = `icon icon-${type}`

    if (color) {
        classes += `-${color}`
    }

    if (hoverColor) {
        classes += ` icon-${type}-${hoverColor}-hover`
    }

    classes += ` icon-${size}`

    if (className) {
        classes += ` ${className}`
    }

    return <i className={classes} />
}

export type IconType =
    | 'add'
    | 'albatross'
    | 'albatrossCircled'
    | 'albatrossDivider'
    | 'ambassador'
    | 'ambassadorCircled'
    | 'arrowdown'
    | 'arrowleft'
    | 'arrowright'
    | 'arrowup'
    | 'briefcase'
    | 'burger'
    | 'calendar'
    | 'camera'
    | 'clock'
    | 'consul'
    | 'consulCircled'
    | 'cross'
    | 'crossCircled'
    | 'crossRound'
    | 'dashCircled'
    | 'drawnArrowLeft'
    | 'drawnArrowRight'
    | 'edit'
    | 'facebook'
    | 'findFriends'
    | 'fireworks'
    | 'forward'
    | 'googlePlus'
    | 'group'
    | 'groupCircled'
    | 'guide'
    | 'home'
    | 'info'
    | 'inviteFriends'
    | 'lock'
    | 'logoAlbatross'
    | 'mapMarker'
    | 'meetingpoint'
    | 'members'
    | 'messages'
    | 'messagesCircled'
    | 'moreVert'
    | 'nationality'
    | 'newcomerBuddy'
    | 'phone'
    | 'pin'
    | 'pinterest'
    | 'price'
    | 'questionMark'
    | 'school'
    | 'search'
    | 'settings'
    | 'start'
    | 'support'
    | 'tag'
    | 'tick'
    | 'tickCircled'
    | 'trash'
    | 'travel'
    | 'twinkle'
    | 'user'
    | 'view'
    | 'wifi'
    | 'star'
    | 'starOutline'
    | 'chevronLeft'

export type IconSize = 'smaller' | 'small' | 'standard' | 'large' | 'larger' | 'largest' | 'elastic'

// Values coming from util/grunt/config/svg.js
export type IconColor =
    | 'darkGrey'
    | 'midGrey'
    | 'lightGrey'
    | 'darkBlue'
    | 'midBlue'
    | 'red'
    | 'yellow'
    | 'green'
    | 'white'
    | 'disabledButton'
    | 'blue'

export default Icon
